import { MutationTree } from "vuex";
import { EventsStateInterface } from "./state";
import EventBus from "src/services/event-bus";
import { EventItem } from "../../models";

const mutation: MutationTree<EventsStateInterface> = {
  initSession(state: EventsStateInterface, payload: { session_guid: string }) {
    if (!state.sessions[payload.session_guid]) {
      state.sessions[payload.session_guid] = {
        guid: payload.session_guid,
        events: [],
      };
    }
  },

  unshiftEvents(state: EventsStateInterface, payload: { events: EventItem[] }) {
    const session_events: { [key: string]: EventItem[] } = {};
    payload?.events?.forEach((event) => {
      const index = state.sessions[event.session_guid].events.findIndex(
        (x) => x.guid == event.guid
      );
      if (index > -1) {
        state.sessions[event.session_guid].events[index] = event;
      } else {
        if (session_events[event.session_guid]) {
          session_events[event.session_guid].push(event);
        } else {
          session_events[event.session_guid] = [event];
        }
      }
    });
    Object.keys(session_events).forEach((session_guid) => {
      state.sessions[session_guid].events.unshift(
        ...session_events[session_guid]
      );
    });
  },

  pushEvents(state: EventsStateInterface, payload: { events: EventItem[] }) {
    const session_events: { [key: string]: EventItem[] } = {};
    payload?.events?.forEach((event) => {
      const index = state.sessions[event.session_guid].events.findIndex(
        (x) => x.guid == event.guid
      );
      if (index > -1) {
        // удаляем событие, а не обновляем, так как у него могла изменитсья дата
        // и нам нужно будет всnавить его в правильную позицию
        // например: у клиента могло не правильно идти время на устройстве
        state.sessions[event.session_guid].events.splice(index, 1);
      }
      if (session_events[event.session_guid]) {
        session_events[event.session_guid].push(event);
      } else {
        session_events[event.session_guid] = [event];
      }
    });
    Object.keys(session_events).forEach((session_guid) => {
      session_events[session_guid].forEach((new_event) => {
        //#region вставляем событие в массив с учетом даты, чтобы отображать корректную последовательность, так как pws присылает события в рандомном порядке
        const length = state.sessions[session_guid].events.length;
        if (length) {
          for (let i = length; i > 0; i--) {
            const event = state.sessions[session_guid].events[i - 1];
            if (new Date(new_event.at) > new Date(event.at)) {
              state.sessions[session_guid].events.splice(i, 0, new_event);
              break;
            } else if (i == 1) {
              state.sessions[session_guid].events.unshift(new_event);
              break;
            }
          }
        } else {
          state.sessions[session_guid].events = [new_event];
        }
        //#endregion
        EventBus.$emit("new:event", { event: new_event });
      });
    });
  },

  markEventAsNew(state: EventsStateInterface, payload: { event: EventItem }) {
    state.new_events.push(payload.event);
  }
};

export default mutation;
